<template>
    <div class="case-index">
        <div class="case">
            <banHead :bannerHead="bannerHead"></banHead>
        </div>
        <!--content-->
        <section>
            <div class="case-content">
                <div class="case-news center" v-for="(news,index) in caseNews['caseNews']" :index="index">
                    <div class="case-detail">
                        <div class="detail-mes">
                            <h3 class="common-font">{{news.name}}</h3>
                            <h2 class="common-font">{{news.title}}</h2>
                            <p>{{news.mes}}</p>
                        </div>
                        <div class="detail-pro">
                            <h1>{{news.number}}<span>{{news.unit}}</span>
                            </h1>
                            <p>{{news.detail}}</p>
                        </div>
                    </div>
                    <img :src="news.url" :_src='news.url1' alt="">

                </div>
            </div>
            <!--partner-->
            <div class="partner-cont center">
                <div class="partner-head">
                    <h1 class="common-font">Business customers</h1>
                    <p>Together with our partners, we are proud to provide IoT solutions and services to more than 700 brands in 65 countries worldwide</p>
                </div>
                <div class="partner-icon">
                    <ul>
                        <li v-for="(icon,key) in caseIcons">
                            <i :style="{'background-image':'url('+icon.iconUrl+')'+'no-repeat'+'center'}" :_src="icon.iconUrl1" :class="icon.iconTitle"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import caseNews from '../assets/js/case';
    import banHead from '../common/banHead';

    export default {

        name: "case",
        data() {
            return {
                bannerHead: {
                    title: 'Case Studies',
                    msg: 'The most profound technologies are those that disappear.',
                    _src:'/static/image/case/CaseStudies-banner@2x.jpg'
                },

                caseNews: caseNews.caseNews,
                caseIcons: caseNews.caseNews.caseIcons
            }
        },
        created() {
            // this.show()
        },
        mounted(){
            this.utils.getImg()

        },
        methods: {
            // show() {
            //     console.log(caseNews.caseNews.caseIcons);
            // }
        },
        components: {
            banHead
        }
    }
</script>

<style lang="less">
    @baseWidth: 1640px;
    @baseColor: #5D5D5D;
    @baseFontColor: #252525;
    .case-index {
        width: 100%;
        .center{
            width: @baseWidth;
            margin: 0 auto;
        }
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        h1 {
            font-size: 40px;
            line-height: 64px;
        }
        p {
            font-size: 16px;
            line-height: 26px;
        }
        .case {
            width: 100%;
            .com-banner {
                background: url("/static/image/case/CaseStudies-banner@1x.jpg") no-repeat center;
                background-size: cover;

            }
        }
        /*content*/
        section {
            /*case案例*/
            .case-content {
                .case-news {
                    margin: 144px auto 0;
                    img {
                        display: block;
                        width: 100%;
                    }
                    .case-detail {
                        width: 100%;
                        /*padding: 0 140px;*/
                        margin-bottom: 64px;
                        display: flex;
                        justify-content: space-between;
                        color: @baseColor;
                        .detail-mes {
                            width: 50%;
                            /*padding-right: 20px;*/
                            h3 {
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 8px;
                            }
                            h2 {
                                font-size: 36px;
                                color: @baseFontColor;
                                line-height: 52px;
                                margin-bottom: 24px;
                            }
                        }
                        .detail-pro {
                            width: 36%;
                            h1 {
                                font-size: 72px;
                                color: @baseFontColor;
                                line-height: 90px;
                                span {
                                    font-size: 18px;
                                }
                            }
                            p{
                                font-size: 14px;
                                line-height: 22px;
                            }
                        }
                    }
                }
                & .case-news:nth-child(6) .case-detail .detail-pro h1 {
                    font-size: 24px;
                    line-height: 32px;
                    color: @baseFontColor;
                    span {
                        display: block;
                        font-size: 18px;
                        line-height: 26px;
                        margin: 24px 0 16px;
                    }
                }
            }
            .partner-cont {
                margin: 106px auto 106px;
                .partner-head {

                    h1 {
                        font-size: 36px;
                        color: @baseFontColor;
                        text-align: center;
                        line-height: 36px;

                    }
                    p {
                        width: 560px;
                        margin: 30px auto 64px;
                        color: @baseColor;
                        text-align: center;
                    }
                }
                .partner-icon {
                    width: 1081px;
                    margin: 0 auto;
                    ul {
                        display: flex;
                        flex: 1;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        li {
                            width: 240px;
                            height: 120px;
                            margin-bottom: 8px;
                            text-align: center;
                            i {
                                width: 240px;
                                height: 120px;
                                display: block;
                                background-size: contain !important;
                                margin: 0 auto;
                            }

                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1680px){
        @baseWidth: 1216px;
        @autoWidth:1256px;
        .case-index {
            width: 100%;
            min-width: @autoWidth;
            .center{
                width: @baseWidth;
                margin: 0 auto;
            }
            section {
                .case-content {
                    .case-news {
                        img {
                            display: block;
                            width: 100%;
                        }
                        .case-detail {
                            padding: 0;
                            .detail-mes,.detail-pro{
                                /*width: 60%;*/
                            }
                            /*p {*/
                                /*font-size: 16px;*/
                                /*line-height: 24px;*/

                            /*}*/

                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/case.vue